
export function CoreValues() {
  const values = [
    {
      icon: 'ri-search-line',
      title: '전국 제조업체 발굴',
      description: '부산, 보령, 목포 등 전국 각지의 숨은 우수 제조업체를 한눈에 비교하고 선택할 수 있습니다. 지역 제한 없이 최고의 품질을 찾아보세요.',
    },
    {
      icon: 'ri-hand-coin-line',
      title: '중간 유통 없는 직거래',
      description: '제조업체와 선장·선주를 직접 연결하여 불필요한 유통 마진을 제거했습니다. 합리적인 가격으로 더 나은 품질의 제품을 만나보세요.',
    },
    {
      icon: 'ri-shield-check-line',
      title: '검증된 품질 보장',
      description: '모든 등록 제조업체는 엄격한 검증 절차를 거칩니다. 인증서, 실제 사용 후기, 품질 보증으로 안심하고 거래하세요.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '전문가 상담 지원',
      description: '1등항해사 출신 전문가가 제품 선택부터 거래까지 전 과정을 지원합니다. 어선 운영 경험을 바탕으로 최적의 솔루션을 제안합니다.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            왜 <span className="text-ocean-600">만선허브</span>인가요?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            어선 물품 공급의 새로운 기준을 제시하는 만선허브의 핵심 가치를 확인하세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-ocean-200 group"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-ocean-500 to-ocean-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${value.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
